module.exports = __webpack_public_path__ + "static/media/Timer 7.bfae3e9a.png";